const FAX_STATUS_META = {
	created: { color: "grey", icon: "mdi-file-outline" },
	queued: { color: "blue-grey", icon: "mdi-tray-full" },
	sending: { color: "amber darken-2", icon: "mdi-progress-upload" },
	requested: { color: "amber darken-2", icon: "mdi-progress-clock" },
	sent: { color: "light-green darken-1", icon: "mdi-send-check" },
	delivered: { color: "success", icon: "mdi-check-circle" },
	failed: { color: "error", icon: "mdi-alert-circle" },
	receiving: { color: "amber darken-2", icon: "mdi-progress-download" },
	received: { color: "success", icon: "mdi-check-circle" }
};

const FALLBACK_META = { color: "grey", icon: "mdi-help-circle" };

/**
 * Returns display metadata (color + icon) for a fax transmission status.
 * @param {string} status
 * @returns {{ color: string, icon: string }}
 */
export function faxStatusMeta(status) {
	return FAX_STATUS_META[status] ?? FALLBACK_META;
}

const COMPLETED_OUTBOUND_STATUSES = ["sent", "delivered"];

/**
 * True once the transmission is complete: outbound faxes that were sent
 * (or delivered), inbound faxes that were fully received.
 * @param {{ direction?: string, status?: string } | null} fax
 * @returns {boolean}
 */
export function isFaxCompleted(fax) {
	if (!fax) return false;

	if (fax.direction === "inbound") {
		return fax.status === "received";
	}

	return COMPLETED_OUTBOUND_STATUSES.includes(fax.status);
}

/**
 * A fax can be deleted once its transmission is over: completed or failed.
 * @param {{ direction?: string, status?: string } | null} fax
 * @returns {boolean}
 */
export function isFaxDeletable(fax) {
	return isFaxCompleted(fax) || fax?.status === "failed";
}

/**
 * An inbound fax that has arrived but was never viewed, printed or downloaded.
 * @param {{ direction?: string, status?: string, readAt?: unknown } | null} fax
 * @returns {boolean}
 */
export function isFaxUnread(fax) {
	return fax?.direction === "inbound" && fax?.status === "received" && !fax?.readAt;
}
